import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AIG from "../../../assets/Logo/AIG";
import Automoby from "../../../assets/Logo/Automoby";
import Autonomo from "../../../assets/Logo/Autonomo";
import At from "../../../assets/Icon/At"; 
import cl from './Forgot.module.css'
import Form from '../../../assets/Style/Form.module.css'
import { Link } from 'react-router-dom';  
import { AppContext } from '../../../providers/appProvider';
import ErrorModal from '../ErrorModal/ErrorModal';
import OkModal from '../OkModal/OkModal';
import { baseFileURL } from '../../../Api';  
import ContainerLogo from '../../../assets/Logo/ContainerLogo';
import { useAuth } from '../../../providers/authProvider'; 
import { useTranslation } from 'react-i18next';
import Flag from '../../UI/Flag/Flag';

function Forgot() {
    const { t, i18n } = useTranslation();
    const auth = useAuth()
    const navigate = useNavigate();  

 
    const { appState, app } = useContext(AppContext);

    const [login, setLogin] = useState("") 
  
    

    const handleSubmit = async (e) => {
        e.preventDefault(); 

        auth.forgotPassword(login).then((response) => { 

            app.setOk("ელ. ფოსტაზე და მაილზე გამოიგზავნა ახალი პაროლი.")
            navigate('/login'); 
            

        }).catch((error) => {
            app.setError("მომხმარებელი: "+ login +" ვერ მოიძებნა")
        });
  

        /*

        try { 
            const response = await userService.forgot(login)

        } catch (error) {
            app.setError("მომხმარებელი ვერ მოიძებნა")
        }
        */


    }

    return <div className='themeCRM' data-theme="light" data-company={
        baseFileURL === 'https://i-logistics.net' ||  baseFileURL === 'https://dev.i-logistics.net' ? (
            'ilogistics'
        ) : baseFileURL === 'https://finance.automoby.ge' ? (
            'automoby'
        ) : baseFileURL === 'https://crm.autonomo.kz' ? (
            'autonomo'
        ) : baseFileURL === 'https://crm.aig.com.ge' ||  baseFileURL === 'https://crmdev.aig.com.ge' ? (
            'aig'
        ) : (
       'automoby'
    )} style={{ height: '100vh' }}>
        <div className={cl.bgLight} >
            <div className={cl.Page} >
                <div className={cl.Head} >

                    {baseFileURL === 'https://i-logistics.net' ||  baseFileURL === 'https://dev.i-logistics.net' ? (
                        <div className={cl.LogoContainer}>
                            <ContainerLogo  />
                            <span>i-Logistics</span>  
                        </div>
                    ) : baseFileURL === 'https://finance.automoby.ge' ? (
                        <Automoby /> 
                    ) : baseFileURL === 'https://crm.autonomo.kz' ? (
                        <Autonomo /> 
                    ) : baseFileURL === 'https://crm.aig.com.ge' ||  baseFileURL === 'https://crmdev.aig.com.ge' ? (
                        <AIG />
                    ) : (
                        <Automoby /> 
                    )}





                    <div className={cl.langlist}>
                            <span
                            className={i18n.language === 'ka' ? cl.langActive : ''}
                            onClick={() => i18n.changeLanguage('ka')}
                            >
                            <Flag countryCode={'ge'} />
                            </span>
                            <span
                            className={i18n.language === 'en' ? cl.langActive : ''}
                            onClick={() => i18n.changeLanguage('en')}
                            >
                            <Flag countryCode={'gb'} />
                            </span>
                            <span
                            className={i18n.language === 'ru' ? cl.langActive : ''}
                            onClick={() => i18n.changeLanguage('ru')}
                            >
                            <Flag countryCode={'ru'} />
                            </span>
                    </div>

                
                </div>
                <div className={cl.Box} >

                {appState.ok && <OkModal message={appState.ok} onClose={() => app.clearOk(false)} />}
                {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}


                    <form className={cl.Form} onSubmit={handleSubmit}>
                        <div className={Form.groupInput}>
                            <label>{t('Email')}</label>
                            <div className={Form.groupInputIcon}>
                                <input
                                    type="email"
                                    className={Form.input} 
                                    value={login}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^A-Za-z0-9.@\-_]/g, '').toUpperCase();
                                    }}
                                    onChange={e => setLogin(e.target.value)}
                                />
                                <div className={Form.crmIcon}>
                                    <At />
                                </div>
                            </div>
                        </div>
                     

                        <div className={Form.groupInput + ' ' + cl.mt1}>
                            <button type="submit" className={cl.btnPrimary}>{t('SendPassword')}</button>
                        </div>
                        
                        <Link to="/login"  className={  cl.AddBtn } >{t('Authorization')} </Link>


            


                    </form>
                </div>
            </div>
        </div>  
    </div> ;
}

export default Forgot;
